import { LeaseType } from '../vehicle-card.types';
export var getPriceVatText = function (leaseType) {
    switch (leaseType) {
        case LeaseType.PERSONAL:
            return '(inc. VAT)';
        case LeaseType.BUSINESS:
            return '(exc. VAT)';
        default:
            return '';
    }
};
